import type { BaseAutocompleteItemProps, ProductsCollectionValue } from "./types";
import { Box } from "@ui/components/layout/box/Box";
import { Grid } from "@ui/components/layout/grid/Grid";
import { ProductHits } from "@components/commerce/product-listing/product-tile-list/ProductHits";
import { useBreakpoint } from "@ui/hooks/useBreakpoint";

export interface ProductsGridProps extends BaseAutocompleteItemProps<ProductsCollectionValue> {}

export const ProductsGrid = ({ autocomplete, collection }: ProductsGridProps) => {
    const lg = useBreakpoint("lg");
    const { items = [] } = collection || {};

    return (
        <Box
            data-testid="AutocompleteProductGrid"
            key="autocompleteProductGrid-key"
            height="100%"
            width="100%"
            display={{ base: "none", lg: "block" }}
        >
            <Box className="aa-Source" bg="white" overflowX="auto" pb={[0, items?.length > 0 && 4]}>
                {items?.length > 0 && (
                    <Grid
                        data-testid="ProductHitsGrid"
                        gap={"0.2"}
                        className="aa-GridItem"
                        {...autocomplete?.getListProps()}
                        gridTemplateColumns={["1fr 1fr", "1fr 1fr", "1fr 1fr", "1fr 1fr 1fr"]}
                        key={`autocompleteKey-gridItemProduct`}
                    >
                        {items?.length > 0 && (
                            <ProductHits
                                key={`productHits`}
                                productListHits={lg ? items : items.slice(0, -1)}
                                isFromSearch={true}
                            />
                        )}
                    </Grid>
                )}
            </Box>
        </Box>
    );
};
